import { render, staticRenderFns } from "./56.vue?vue&type=template&id=c354246a&scoped=true&"
var script = {}
import style0 from "./56.vue?vue&type=style&index=0&id=c354246a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c354246a",
  null
  
)

export default component.exports